module.exports = __webpack_public_path__ + "img/avatar7.0fe58e38.png";